import { useCurrentExtranet } from "@/features/admin/hooks/queries";
import type { AppLocale } from "@/lib/locale/resolve-effective-locale";

/**
 * Language the extranet's dashboards are shown in. Differs from `useLocale()`
 * on admin routes (always "nl"); use it for content the CMS saves for viewers.
 */
export function useExtranetLocale(): AppLocale {
  const { data: extranet } = useCurrentExtranet();
  return extranet?.locale ?? "nl";
}
